import { Badge } from "@/components/ui/badge";
import { useTranslation } from "react-i18next";
import { AgreementStatus } from "@/types/agreement";

interface AgreementStatusBadgeProps {
  status: AgreementStatus;
  className?: string;
}

export const AgreementStatusBadge = ({
  status,
  className,
}: AgreementStatusBadgeProps) => {
  const { t } = useTranslation();

  return (
    <Badge variant="secondary" className={className}>
      {t(`agreementStatuses.${status}`)}
    </Badge>
  );
};
